module.exports = __webpack_public_path__ + "02_medium_brown.50306397.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_medium_brown.png
// module id = GJ/B
// module chunks = 0